import { memo, useEffect, useRef } from 'react';
import { renderAsync } from 'docx-preview';
import { RendererPropsData } from '../../types';
// import { copyArrayBuffer } from '../../../../utils';

export const DocxRenderer = memo(
  ({ fileObj }: { fileObj: RendererPropsData }) => {
    const refDocxWrapper = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (refDocxWrapper.current) {
        // const data =
        //   'file' in fileObj
        //     ? new Blob([fileObj.file], {
        //         type: fileObj.file.type || 'application/*',
        //       })
        //     : copyArrayBuffer(fileObj.arrayBuffer);
        renderAsync(
          new Blob([fileObj.file], {
            type: fileObj.file.type || 'application/*',
          }),
          refDocxWrapper.current
        );
      }
    }, [refDocxWrapper]);

    return <div ref={refDocxWrapper} className={'docx-render-container'}></div>;
  }
);
